import { AxiosRequestConfig } from "axios";
import { Axios } from "./axios";

export async function get(url: string, config?: AxiosRequestConfig | undefined) {
  return Axios.get(`${url}`, config)
    .then((res) => res.data)
    .catch((e) => console.log(e));
}

export async function post(url: string, body?: any) {
  return Axios.post(`${url}`, body).then((res) => res.data);
}

export async function put(url: string, body?: any) {
  return Axios.put(`${url}`, body).then((res) => res.data);
}
